import styles from '../subjects/subject.module.css'
import React, { useEffect, useState } from 'react'
import { Action, Active, Inactive, Left, Right, RightArrow, Search, Status } from '../../svg'
import { formselect, selectInput } from '../MaterialUI';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Selects from 'react-select'
import { custom, save } from '../MaterialUI';
import { MenuButton, Dropdown, Menu, MenuItem as MenuAction } from '@mui/joy'
import EditChapter from './EditChapter';
import Api from '../../helper/api';
import * as yup from "yup";
import Toastify from '../../helper/Toastify';
import { useFormik } from 'formik';
import Delete from '../../shared/Delete/Delete';


const Chapters = () => {
  const toast = new Toastify();
  const api = new Api();

  // states-------------
  const [open, setOpen] = useState(false);
  const [openDlt, setOpenDlt] = useState(false);
  const [chapterToDelete, setChapterToDelete] = useState("")
  const [statuss, setStatus] = useState("");
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(50)
  const [totalPages, setTotalPages] = useState(1)
  const [totalItems, setTotalItems] = useState(0);
  const [chapterToEdit, setChapterToEdit] = useState({
    name: '', code: '', status: ''
  })
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [sub, setSub] = useState("");

  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;

  // increment the page------------------------
  const increment = () => {
    if (page < totalPages) {
      setPage((prev) => prev + 1)
    }
  }

  // decrement the page------------------------
  const decrement = () => {
    if (page > 1) {
      setPage((prev) => prev - 1)
    }
  }

  // open the edit popup----------------------
  const handleOpen = (chapter) => {
    setOpen(true)
    setChapterToEdit(chapter)
  };


  // close the edit popup---------------------
  const handleClose = () => setOpen(false);

  // fetch all subject -------------------------
  const AllSubject = async () => {
    try {
      const { data, status } = await api.subject("", "?");
      if (status === 200) {
        setSubjects(data.data)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // fetch all chapters -------------------------
  const AllChapter = async () => {
    try {
      const { data, status } = await api.chapter({}, `?search=${search}&page=${page}&status=${statuss}&limit=${limit}`);
      if (status === 200) {
        setChapters(data.data)
        setTotalPages(data.totalPages)
        setTotalItems(data.totalItems)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // schema --------------------
  const schema = yup.object().shape({
    name: yup.string().required("Name is required"),
    code: yup.string().required("Code is required"),
    status: yup.string().required("Status is required"),
    subject: yup.string().required("Subject is required")
  })


  // formik to handle forms data --------------------
  const {
    errors,
    values,
    handleChange,
    handleReset,
    touched,
    handleBlur,
    handleSubmit,
    setFieldValue,
    resetForm
  } = useFormik({
    initialValues: {
      name: "",
      code: "",
      status: '',
      subject: ""
    },
    validationSchema: schema,
    onSubmit: () => {
      AddChapter();
    }
  })

  // add subject -----------------------
  const AddChapter = async () => {
    try {
      const { data, status } = await api.addChapter(values)
      if (status === 200) {
        setRefresh(!refresh)
        resetForm();
        setSub("")
        toast.success("Saved Successfully", "Your changes have been saved successfully")
      }
    } catch (err) {
      if (err.response) {
        toast.error("Error occured", err.response.data.message)
      }
    }
  }

  // run on initial render-------------------
  useEffect(() => {
    AllChapter();
  }, [refresh, page, search, statuss, limit])


  // fetch all subjects on initial render 
  useEffect(() => {
    AllSubject();
  }, [])

  // delete chapter ------------------------
  const handleDelete = async () => {
    try {
      const { data, status } = await api.trashChapter("", { id: chapterToDelete })
      if (status === 200) {
        setRefresh(!refresh)
        setOpenDlt(false)
        setChapterToDelete("")
        toast.success("Deleted Successfully", "Your changes have been saved successfully")
      }
    } catch (err) {
      if (err.response) {
        toast.error("Error occured", err.response.data.message)
      }
    }
  }

  const handleCancel = () => {
    handleReset()
    setSub("");
  }

  return (
    <div className={styles.container}>
      <EditChapter
        handleClose={handleClose}
        open={open}
        subjects={subjects}
        chapterToEdit={chapterToEdit}
        refresh={refresh}
        setRefresh={setRefresh} />
      <Delete handleClose={() => setOpenDlt(false)} open={openDlt} handleDelete={handleDelete} />
      <div className={styles.head}>
        <h1>Master Data</h1>
        <span>
          home <RightArrow /> Master Data <RightArrow /> <span style={{ color: 'var(--Gray-900, #191B1C)' }}>Chapter</span>
        </span>
      </div>
      <div className={styles.main}>
        <div className={styles.left}>
          <div className={styles.subhead}>
            <Select className={styles.selectinput}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              sx={selectInput}
              value={statuss}
              onChange={(e) => setStatus(e.target.value)}
              IconComponent={Status}
              displayEmpty
              defaultValue=''
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="ACTIVE">Active</MenuItem>
              <MenuItem value="INACTIVE">Inactive</MenuItem>
            </Select>
            <div className={styles.search}><Search /> <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} placeholder='Search' /></div>
          </div>
          <div className={styles.header}>
            <div className={styles.fourth}>no.</div>
            <div className={styles.sixth}>subject name</div>
            <div className={styles.sixth}>Chapter name</div>
            <div className={styles.fifth}>code</div>
            <div className={styles.fifth}>status</div>
            <div className={`${styles.fifth} ${styles.flexEnd}`}>action</div>
          </div>

          {
            chapters.map((chapter, index) => (
              <div className={styles.info}>
                <div className={styles.fourth}>{(page - 1) * 10 + index + 1}</div>
                <div className={styles.sixth}>{chapter?.subject.name}</div>
                <div className={styles.sixth}>{chapter.name}</div>
                <div className={styles.fifth}>{chapter.code}</div>
                <div className={styles.fifth}>
                  {
                    chapter.status === 'ACTIVE'
                      ? <span className={styles.active}>
                        <Active /> Active
                      </span>
                      : <span className={styles.inactive}>
                        <Inactive /> Inactive
                      </span>
                  }
                </div>
                <div className={`${styles.fifth} ${styles.flexEnd}`}><Dropdown>
                  <MenuButton style={{ border: 'none', padding: '0' }}><Action /></MenuButton>
                  <Menu>
                    <MenuAction onClick={() => handleOpen(chapter)}>Edit</MenuAction>
                    <MenuAction onClick={() => {
                      setOpenDlt(true)
                      setChapterToDelete(chapter._id)
                    }}>Delete</MenuAction>
                  </Menu>
                </Dropdown></div>
              </div>
            ))
          }

          <div className={styles.pagination}>
            <div>
              Rows per page:
              <Dropdown>
                <MenuButton style={{ border: 'none', padding: '0' }}>
                  <div>
                    {limit}
                  </div>
                </MenuButton>
                <Menu>
                  <MenuAction onClick={() => setLimit(15)} >15</MenuAction>
                  <MenuAction onClick={() => setLimit(25)} >25</MenuAction>
                  <MenuAction onClick={() => setLimit(50)} >50</MenuAction>
                  <MenuAction onClick={() => setLimit(75)} >75</MenuAction>
                  <MenuAction onClick={() => setLimit(100)} >100</MenuAction>
                </Menu>
              </Dropdown>
            </div>
            <div>Showing {start} to {end} of {totalItems} entries</div>
            <div>
              <Right handleClick={decrement} />
              {/* <p>01</p> */}
              <p className={styles.onPage}>{page}</p>
              <Left handleClick={increment} />
            </div>
          </div>
        </div>

        <div className={styles.right}>
          <h5>Add New Chapter</h5>

          <label>Subject Name</label>
          <br />
          <div style={{ marginBottom: "21px", marginTop: "6px" }}>
            <Selects
              options={subjects.map((subject) => {
                return {
                  value: subject._id,
                  label: subject.name
                }
              })}
              onChange={(e) => {
                setSub(e)
                setFieldValue("subject", e.value)
              }}
              name='subject'
              value={sub}
              styles={{
                input: (styles) => ({ ...styles, fontSize: "14px", color: "#8C94A3 !important" }),
                container: (styles) => ({ ...styles, width: "100%" }),
                control: () => ({ display: "flex", border: "1px solid #E9EAF0", borderRadius: "4px", outline: "none", padding: 3, color: "#8C94A3 !important" }),
                placeholder: (styles) => ({ ...styles, fontSize: 14, color: "#8C94A3" }),

              }}
            />
          </div>
          {
            errors.subject && touched.subject && <p style={{ color: "red", fontSize: "12px", position: "relative", height: 0, top: "-14px" }}>{errors.subject}</p>
          }
          <label>Chapter Name</label>
          <br />
          <div className={styles.input}>
            <input type="text" placeholder='Enter' name='name' value={values.name} onChange={handleChange} onBlur={handleBlur} />
          </div>
          {
            errors.name && touched.name && <p style={{ color: "red", fontSize: "12px", position: "relative", height: 0, top: "-14px" }}>{errors.name}</p>
          }
          <label>Code</label>
          <br />
          <div className={styles.input}>
            <input type="text" name='code' value={values.code} onChange={handleChange} onBlur={handleBlur} placeholder='Enter' />
          </div>
          {
            errors.code && touched.code && <p style={{ color: "red", fontSize: "12px", position: "relative", height: 0, top: "-14px" }}>{errors.code}</p>
          }
          <label>Status</label>
          <br />
          <Select className={styles.formselect}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            sx={formselect}
            onChange={handleChange}
            onBlur={handleBlur}
            name='status'
            value={values.status}
            IconComponent={Status}
            displayEmpty
            defaultValue=''
          >
            <MenuItem value="">status</MenuItem>
            <MenuItem value="ACTIVE">Active</MenuItem>
            <MenuItem value="INACTIVE">Inactive</MenuItem>
          </Select>
          {
            errors.status && touched.status && <p style={{ color: "red", fontSize: "12px", position: "relative", height: 0, top: "-5px" }}>{errors.status}</p>
          }
          <div className={styles.buttons}>
            <Button sx={custom} disableElevation variant="contained" onClick={handleCancel}>Cancel</Button>
            <Button sx={save} disableElevation variant="contained" onClick={handleSubmit}>save</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Chapters
